import clsx from 'clsx';

/** Greyed-out placeholder for features that require sign-in. */
export default function DisabledMemberFeature({ title, hint, children, className }) {
  return (
    <div
      className={clsx(
        'bg-slate-900 border border-slate-800 rounded-2xl p-4 opacity-50 cursor-not-allowed select-none',
        className,
      )}
      aria-disabled="true"
      title={hint}
    >
      {title && (
        <p className="text-sm font-semibold text-slate-400 mb-2">{title}</p>
      )}
      {children}
      {hint && (
        <p className="text-xs text-slate-500 mt-3">{hint}</p>
      )}
    </div>
  );
}
